// ----------------------------------------------------------------------
// <copyright file="Izenda.Access.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');
  var trackable = require('share/tracking/Izenda.Trackable');
  var PagingModel = require('share/components/controls/DataGrid/helpers/Izenda.PagingModel');
  var AccessConstants = require('logic/data/Izenda.AccessConstants');
  var DEFAULT_VALUE = AccessConstants.DEFAULT_VALUE;
  var AccessDetail = require('./Izenda.AccessDetail');
  var ObjectStateConstants = require('logic/data/Izenda.ObjectStateConstants');
  const {
    filter,
    isEmpty,
    every,
    some,
    map,
    forEach,
    unionBy,
    omit,
    remove,
    uniqueId,
    invoke,
    find
  } = require('lodash/fp');

  function Access(data) {
    this.draftAccesses = []; // This keep access list orign and add new access for support search, pagging, sort.
    (this.accessRight = []), (this.reportAccessRight = []), (this.dashboardAccessRight = []);

    var props = {
      pageInfo: new PagingModel(DEFAULT_VALUE.SORT_DIRS, DEFAULT_VALUE.SEARCH_CRITERIA),
      accessList: [], // It's a array of the AccessDetail item
      visibleAccessList: function() {
        return filter(function(access) {
          return access.state !== 2;
        }, this.accessList);
      },
      hasNoActiveAccess: function() {
        return isEmpty(this.visibleAccessList);
      },
      hasSelectAllActiveAccess: function() {
        if (this.hasNoActiveAccess) {
          return false;
        }
        return every('selected', this.visibleAccessList);
      },

      hasActiveInstancesSelected: function() {
        if (this.hasNoActiveAccess) {
          return false;
        }
        return some('selected', this.visibleAccessList);
      },

      hasAsLeastAccessHasRoleSelect: function() {
        return some('hasRolesAccessor', this.visibleAccessList);
      },

      hasAsLeastAccessHasUserSelect: function() {
        return some('hasUserAccessor', this.visibleAccessList);
      }
    };

    m.extendObservable(trackable(this), props);
    data && this.populateData(data);
  }

  /**
   * Populate data
   * @param  {Object} access object
   */
  Access.prototype.populateData = m.action(function(data) {
    this.accessList = map(function(item) {
      return new AccessDetail(item);
    }, data.accessList);
    // update access Id for draft access if need
    forEach(
      function(access) {
        var item = find({ tempId: access.tempId }, this.draftAccesses);
        if (item) {
          item.id = access.id;
        }
      }.bind(this),
      data.accessList
    );

    this.resetDirty();
  });

  /**
   * Populate data
   * @param  {Object} List data of access  detail
   */
  Access.prototype.populateAccessDetails = m.action(function(access) {
    this.accessList = map(function(accessDetail) {
      return new AccessDetail(accessDetail);
    }, access.result);

    this.pageInfo.setTotalRecords(access.total || 0);
    this.resetDirty();
  });

  /**
   * Check report access dirty or not
   * @return {boolean} result of dirty
   */
  Access.prototype.checkDirty = function() {
    var dirtyItems = filter(function(item) {
      return item.checkDirty && item.checkDirty();
    }, this.accessList);

    return !isEmpty(dirtyItems) || this.isDirty;
  };

  /**
   * Add new access
   */
  Access.prototype.addAccess = m.action(function() {
    var access = new AccessDetail();
    this.accessList.splice(0, 0, access);
    this.pageInfo.increaseRecord();
    this.markDirty();
  });

  /**
   * Delete access
   */
  Access.prototype.deleteAccess = m.action(function() {
    var pageInfo = this.pageInfo;
    forEach(function(item) {
      if (item.selected) {
        item.delete();
        pageInfo.descreaseRecord();
      }
    }, this.accessList);
    this.markDirty();
  });

  /**
   * Populate list access right data
   * @param {array} access right data
   */
  Access.prototype.populateAccessRight = function(data) {
    this.accessRight = data;
  };

  /**
   * Merge current list access on grid with origin list return when save draft, add new for load data when search, sort, pagging
   * @return {array} list of access
   */
  Access.prototype.mergeWithReportDraftAccess = m.action(function() {
    var updateAccesses = this.getUpdateAccess();
    this.draftAccesses = unionBy('tempId', updateAccesses, this.draftAccesses);
  });

  /**
   * Merge list access update, insert, delete
   * @return {array} list of access
   */
  Access.prototype.getUpdateAccess = function() {
    return filter(function(access) {
      return access.state !== ObjectStateConstants.NONE;
    }, this.accessList);
  };

  /**
   * Update data for access when save
   * @param  {object}  report data
   */
  Access.prototype.readFromReport = m.action(function(report) {
    ensure(report, 'Report cannot be null or undefined');

    this.accessList = map(function(item) {
      return new AccessDetail(item);
    }, report.accesses);
  });

  /**
   * Populate list access right data
   * @param {array} access right data
   */
  Access.prototype.populateReportAccessRight = function(data) {
    this.reportAccessRight = data;
  };

  /**
   * Populate list access right data
   * @param {array} access right data
   */
  Access.prototype.populateDashboardAccessRight = function(data) {
    this.dashboardAccessRight = data;
  };

  /**
   * [getAccessRightByKey description]
   * @param  {[type]} key [description]
   * @return {[type]}     [description]
   */
  Access.prototype.getAccessRightByKey = function(key) {
    return this[key] || [];
  };

  /**
   * getAccessForSave description
   * @param: {bool}  includeStateProperties
   * @return {array} list of access
   */
  Access.prototype.getAccessForSave = function(includeStateProperties) {
    var accesses = filter(function(access) {
      return access.state !== ObjectStateConstants.DELETE;
    }, this.accessList);

    return map(function(access) {
      return includeStateProperties
        ? access.buildDataForSaveAccessSettings()
        : omit('state', access.buildDataForSaveAccessSettings());
    }, accesses);
  };

  /**
   * Remove list accessor when move user/role from selected tree to avaiable tree
   * @param  {array} accessor list accessor (user/role)
   */
  Access.prototype.removeAccessor = function(accessor) {
    forEach(function(access) {
      access.accessors = remove(item => some({ id: item }, accessor), access.accessors);
      access.accessorNames = remove(item => some({ name: item }, accessor), access.accessorNames);
    }, this.accessList);
  };

  /**
   * Clean model dirty
   */
  Access.prototype.cleanDirty = m.action(function() {
    this.resetDirty();
    forEach(function(access) {
      access.resetDirty();
    }, this.accessList);
  });

  /**
   * Populates list access default to access when create new report/template/dashboard
   * @param  {array} accessDefaults
   */
  Access.prototype.populateAccessDefault = function(accessDefaults) {
    this.draftAccesses = map(function(item) {
      item.state = ObjectStateConstants.INSERT;
      item.tempId = uniqueId();

      return new AccessDetail(item);
    }, accessDefaults);
  };

  /**
   * Clean draft access after save report
   */
  Access.prototype.cleanDraftAccesses = m.action(function() {
    // clean draft access after save
    this.draftAccesses = [];
    // Clean state of access:
    forEach(function(item) {
      item.state = ObjectStateConstants.NONE;
    }, this.accessList);
  });

  /**
   * Clear all access records have share with equal user when checkbok global report checked.
   */
  Access.prototype.clearAllUserAccessor = m.action(function() {
    forEach(function(item) {
      if (item.assignedType === AccessConstants.ASSIGN_TYPE.USER) {
        item.state = ObjectStateConstants.DELETE;
      }
    }, this.accessList);

    this.markDirty();
  });

  /**
   * Remove all global roles in accessor list
   */
  Access.prototype.removeAllGlobalRolesOnAccessor = m.action('removeAllGlobalRolesOnAccessor', function() {
    forEach(invoke('removeAllGlobalRoles'), this.accessList);
  });

  module.exports = Access;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.Access.js